import { Block, type Change, isBlockRangeSelection, Text } from '@gitbook/slate';

import { BLOCK_PARAGRAPH, LEAF_TEXT_BLOCKS } from '../types';

/**
 * Focus the start or end of the document, inserting an empty paragraph if needed.
 */
export function moveToEdgeLeafBlock(
    change: Change,
    position: 'DOCUMENT_START' | 'DOCUMENT_END'
): Change {
    const { document, selection } = change.value;

    if (isBlockRangeSelection(selection)) {
        change.switchSelection();
    }

    const block = (position === 'DOCUMENT_START' ? document.nodes.first() : document.nodes.last())!;

    if (LEAF_TEXT_BLOCKS.includes(block.type)) {
        // if the last block is a paragraph, focus it
        return (
            position === 'DOCUMENT_START'
                ? change.collapseToStartOf(block)
                : change.collapseToEndOf(block)
        ).focus();
    }
    // otherwise append a paragraph and focus it
    const paragraph = Block.create({
        type: BLOCK_PARAGRAPH,
        nodes: [Text.create('')],
    });

    return change
        .insertNodeByKey(
            document.key,
            position === 'DOCUMENT_START' ? 0 : document.nodes.size,
            paragraph
        )
        .collapseToEndOf(paragraph)
        .focus();
}
